import { FC } from 'react';
import {
  Backdrop,
  BackdropProps,
  CircularProgress,
  CircularProgressProps,
  styled,
} from '@mui/material';

export type FullscreenLoaderProps = BackdropProps & {
  CircularProgressProps?: CircularProgressProps;
  hideSpinner?: boolean;
};

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`;

export const FullscreenLoader: FC<FullscreenLoaderProps> = ({
  hideSpinner,
  CircularProgressProps: circularProgressProps,
  ...rest
}) => (
  <StyledBackdrop {...rest}>
    {!hideSpinner && <CircularProgress {...circularProgressProps} />}
  </StyledBackdrop>
);
